import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_layout/defi/portfolio/")({
  beforeLoad: () => {
    throw redirect({
      to: "/defi/portfolio/positions",
      search: { protocolKey: undefined, position: undefined },
    });
  },
});
